export default __webpack_public_path__ + "static/media/7SJ500.ce57a317.jpg";